/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ModelUtils } from '../../cmd/util/ModelUtils';
import { NodeCompat } from '../../compat/NodeCompat';
import { ExternalDocumentation } from '../../core/models/common/ExternalDocumentation';
import { IExternalDocumentationParent } from '../../core/models/common/IExternalDocumentationParent';
import { IPropertyParent } from '../../core/models/common/IPropertyParent';
import { Schema } from '../../core/models/common/Schema';
import { OasXML } from './OasXML';

/**
 * Models an OpenAPI schema.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends Schema
 */
export abstract class OasSchema extends Schema implements IExternalDocumentationParent, IPropertyParent {
    public format : string;

    public title : string;

    public description : string;

    public default_ : any;

    public multipleOf : number;

    public maximum : number;

    public exclusiveMaximum : boolean;

    public minimum : number;

    public exclusiveMinimum : boolean;

    public maxLength : number;

    public minLength : number;

    public pattern : string;

    public maxItems : number;

    public minItems : number;

    public uniqueItems : boolean;

    public maxProperties : number;

    public minProperties : number;

    public required : Array<string>;

    public enum_ : Array<string>;

    public type : string;

    public items : any;

    public allOf : Array<OasSchema>;

    public properties : any;

    public additionalProperties : any;

    public readOnly : boolean;

    public xml : OasXML;

    public externalDocs : ExternalDocumentation;

    public example : any;

    /**
     * Creates a child external documentation model.
     * @return {ExternalDocumentation}
     */
    public abstract createExternalDocumentation() : ExternalDocumentation;

    /**
     * @see io.apicurio.datamodels.core.models.common.IExternalDocumentationParent#setExternalDocumentation(io.apicurio.datamodels.core.models.common.ExternalDocumentation)
     * @param {ExternalDocumentation} externalDocs
     */
    public setExternalDocumentation(externalDocs : ExternalDocumentation) {
        this.externalDocs = externalDocs;
    }

    /**
     * Creates a child XML model.
     * @return {OasXML}
     */
    public abstract createXML() : OasXML;

    /**
     * Creates a child schema model.
     * @return {OasSchema}
     */
    public abstract createAllOfSchema() : OasSchema;

    /**
     * Creates a child schema model.
     * @return {OasSchema}
     */
    public abstract createItemsSchema() : OasSchema;

    /**
     * Creates a child schema model.
     * @return {OasSchema}
     */
    public abstract createAdditionalPropertiesSchema() : OasSchema;

    /**
     * @see IPropertyParent#createPropertySchema(String)
     * @param {string} propertyName
     * @return {Schema}
     */
    public abstract createPropertySchema(propertyName : string) : Schema;

    /**
     * @see IPropertyParent#getPropertyNames()
     * @return {string[]}
     */
    public getPropertyNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        if(ModelUtils.isDefined(this.properties)) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.properties));
        }
        return rval;
    }

    /**
     * @see IPropertyParent#getProperties()
     * @return {Schema[]}
     */
    public getProperties() : Array<Schema> {
        let rval : Array<Schema> = <any>([]);
        if(ModelUtils.isDefined(this.properties)) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.properties));
        }
        return rval;
    }

    /**
     * @see IPropertyParent#addProperty(String, Schema)
     * @param {string} propertyName
     * @param {Schema} schema
     * @return {Schema}
     */
    public addProperty(propertyName : string, schema : Schema) : Schema {
        if(ModelUtils.isNullOrUndefined(this.properties)) {
            this.properties = <any>({});
        }
        /* put */(this.properties[propertyName] = <OasSchema>schema);
        return schema;
    }

    /**
     * @see IPropertyParent#removeProperty(String)
     * @param {string} propertyName
     * @return {Schema}
     */
    public removeProperty(propertyName : string) : Schema {
        if(ModelUtils.isDefined(this.properties)) {
            return /* remove */(map => { let deleted = this.properties[propertyName];delete this.properties[propertyName];return deleted;})(this.properties);
        }
        return null;
    }

    /**
     * @see IPropertyParent#getProperty(String)
     * @param {string} propertyName
     * @return {Schema}
     */
    public getProperty(propertyName : string) : Schema {
        if(ModelUtils.isDefined(this.properties)) {
            return /* get */((m,k) => m[k]===undefined?null:m[k])(this.properties, propertyName);
        }
        return null;
    }

    /**
     * @see IPropertyParent#getRequiredProperties()
     * @return {string[]}
     */
    public getRequiredProperties() : Array<string> {
        return this.required;
    }

    /**
     * @see IPropertyParent#setRequiredProperties(List)
     * @param {string[]} requiredProperties
     */
    public setRequiredProperties(requiredProperties : Array<string>) {
        this.required = requiredProperties;
    }

    /**
     * @see IPropertyParent#isPropertyRequired(String)
     * @param {string} propertyName
     * @return {boolean}
     */
    public isPropertyRequired(propertyName : string) : boolean {
        if(ModelUtils.isDefined(this.required)) {
            return /* contains */(this.required.indexOf(<any>(propertyName)) >= 0);
        }
        return false;
    }

    /**
     * @see IPropertyParent#setPropertyRequired(String)
     * @param {string} propertyName
     */
    public setPropertyRequired(propertyName : string) {
        if(ModelUtils.isNullOrUndefined(this.required)) {
            this.required = <any>([]);
        }
        if(!/* contains */(this.required.indexOf(<any>(propertyName)) >= 0)) {
            /* add */(this.required.push(propertyName)>0);
        }
    }

    /**
     * @see IPropertyParent#unsetPropertyRequired(String)
     * @param {string} propertyName
     */
    public unsetPropertyRequired(propertyName : string) {
        if(ModelUtils.isDefined(this.required)) {
            /* remove */(a => { let index = a.indexOf(propertyName); if(index>=0) { a.splice(index, 1); return true; } else { return false; }})(this.required);
            if(/* isEmpty */(this.required.length == 0)) {
                this.required = null;
            }
        }
    }

    /**
     * Returns true if there is a single items schema.
     * @return {boolean}
     */
    public hasItemsSchema() : boolean {
        return NodeCompat.isNode(this.items);
    }

    /**
     * Returns true if there is a list of items schemas.  Even if there is only one schema in the list.
     * @return {boolean}
     */
    public hasItemsSchemas() : boolean {
        return NodeCompat.isList(this.items);
    }

    /**
     * Returns true if there is an additional properties schema.
     * @return {boolean}
     */
    public hasAdditionalPropertiesSchema() : boolean {
        return NodeCompat.isNode(this.additionalProperties);
    }

    /**
     * Returns true if there is an "additionalProperties" property that is a boolean value and not a schema.
     * @return {boolean}
     */
    public hasAdditionalPropertiesBoolean() : boolean {
        return this.additionalProperties != null && !NodeCompat.isNode(this.additionalProperties);
    }

    /**
     * Adds an AllOf schema.
     * @param {OasSchema} schema
     */
    public addAllOfSchema(schema : OasSchema) {
        if(this.allOf == null) {
            this.allOf = <any>([]);
        }
        /* add */(this.allOf.push(schema)>0);
    }

    /**
     * Removes a allOf schema.
     * @param {OasSchema} schema
     */
    public removeAllOfSchema(schema : OasSchema) {
        if(this.allOf != null) {
            /* remove */(a => { let index = a.indexOf(schema); if(index>=0) { a.splice(index, 1); return true; } else { return false; }})(this.allOf);
        }
    }

    constructor() {
        super();
        if(this.format===undefined) this.format = null;
        if(this.title===undefined) this.title = null;
        if(this.description===undefined) this.description = null;
        if(this.default_===undefined) this.default_ = null;
        if(this.multipleOf===undefined) this.multipleOf = null;
        if(this.maximum===undefined) this.maximum = null;
        if(this.exclusiveMaximum===undefined) this.exclusiveMaximum = null;
        if(this.minimum===undefined) this.minimum = null;
        if(this.exclusiveMinimum===undefined) this.exclusiveMinimum = null;
        if(this.maxLength===undefined) this.maxLength = null;
        if(this.minLength===undefined) this.minLength = null;
        if(this.pattern===undefined) this.pattern = null;
        if(this.maxItems===undefined) this.maxItems = null;
        if(this.minItems===undefined) this.minItems = null;
        if(this.uniqueItems===undefined) this.uniqueItems = null;
        if(this.maxProperties===undefined) this.maxProperties = null;
        if(this.minProperties===undefined) this.minProperties = null;
        if(this.required===undefined) this.required = null;
        if(this.enum_===undefined) this.enum_ = null;
        if(this.type===undefined) this.type = null;
        if(this.items===undefined) this.items = null;
        if(this.allOf===undefined) this.allOf = null;
        if(this.properties===undefined) this.properties = null;
        if(this.additionalProperties===undefined) this.additionalProperties = null;
        if(this.readOnly===undefined) this.readOnly = null;
        if(this.xml===undefined) this.xml = null;
        if(this.externalDocs===undefined) this.externalDocs = null;
        if(this.example===undefined) this.example = null;
    }
}
OasSchema["__class"] = "io.apicurio.datamodels.openapi.models.OasSchema";
OasSchema["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IPropertyParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];




